import { veryDarkBlueText, darkGrayishBlueText, lightGrayishBlueCardBg, whiteText, darkDesaturedBlueCardBg, veryDarkBlueBg } from "./Colors";

export const theme = {
  primaryText: veryDarkBlueText,
  secundaryText: darkGrayishBlueText,
  cardBg: lightGrayishBlueCardBg,
  bodyBg: whiteText,
};

export const themeDark = {
  primaryText: whiteText,
  secundaryText: darkGrayishBlueText,
  cardBg: darkDesaturedBlueCardBg,
  bodyBg: veryDarkBlueBg,
};
